import {addEmployees} from "../reducers/EmployeeReducers";

export function SortNew(jobType) {
    return {
        type: 'employeeSort/SORT_NEW',
        payload: jobType,
    };
}

export function SortOld(jobType) {
    return {
        type: 'employeeSort/SORT_OLD',
        payload: jobType,
    };
}

export function SortAtoZ(jobType) {
    return {
        type: 'employeeSort/SORT_AZ',
        payload: jobType,
    };
}

export function search(term, jobType) {
    return {
        type: 'employee/SEARCH',
        term: term,
        jobType: jobType,
    };
}

export function filter(filterBy, jobType) {
    return {
        type: 'employee/FILTER',
        filterBy: filterBy,
        jobType: jobType,
    };
}

export function addEmployee(values) {
    addEmployees(values)
}
